export default "__VITE_ASSET__DjPDaL4q__"